import React from 'react';
import eye from '../../assets/eye.png'
import './header.css';

const Header = () => (
  <div className="gpt3__header section__padding" id="home">
    <div className="gpt3__header-content">
      <h1 className="gradient__text">Explore the world with Eye-Hear</h1>
      <p>Explore the groundbreaking eye-tracking technology. Experience a new paradigm of intuitive and hands-free interaction across your favorite devices, from computers to smartphones, amplifying accessibility and redefining user engagement.</p>

      <div className="gpt3__header-content__input">
        <input type="email" placeholder="Your Email Address" />
        <button type="button">Get Started</button>
      </div>
    </div>

    <div className="gpt3__header-image">
      <img src={eye} />
    </div>
  </div>
);

export default Header;